import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { patientNoteDelete, patientNoteSetPopup } from '../../lib/redux/actions/patientNotes';
import PatientNote from './PatientNote';
import MASpinner from '../common/MASpinner';

const mapStateToProps = (state) => ({
  ...state.patientNotes,
});

const mapDispatchToProps = {
  patientNoteDelete,
  patientNoteSetPopup,
};

/**
 * MED-922 - every note about a person, across every consultant.
 *
 * Consultant-agnostic by decision: "this family disputes everything" is about the family, not
 * about one consultant's relationship with them. That is the one exception to the MED-889
 * isolation rule, and it is safe only because this panel never renders for a consultant-side
 * user - they are refused the endpoint, and never reach a screen that mounts this.
 *
 * Reads from the store only when the store holds notes for *this* patient. A list left over from
 * the previous patient must not show here, for the same reason the invoice popup checks the tag.
 */
class PatientNotes extends React.Component {
  render() {
    const { patientId, patientNotes, patientNotesForPatientId, isFetchingPatientNotes, patientNoteDelete, patientNoteSetPopup } = this.props;
    const notes = Number(patientNotesForPatientId) === Number(patientId) ? patientNotes : [];

    return (
      <div className="crud__section mb-3 bg-white">
        <div className="crud__section-icon">
          <i className="fas fa-sticky-note" />
        </div>
        <h2 className="crud__section-header">Patient Notes</h2>
        <p className="text-muted mb-3">
          About this person, not about any one invoice. Visible to every internal user, whichever consultant they are working for.
        </p>

        {isFetchingPatientNotes && <MASpinner />}

        {!isFetchingPatientNotes && notes.length === 0 && <p className="text-muted mb-0">No notes have been added about this patient.</p>}

        {!isFetchingPatientNotes && notes.length > 0 && (
          <div className="invoice-batch-single__notes-wrapper">
            <TransitionGroup>
              {notes.map((note) => (
                <CSSTransition key={note.id} timeout={500} classNames="fade">
                  <PatientNote note={note} deleteNote={patientNoteDelete} setPopup={patientNoteSetPopup} />
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
        )}
      </div>
    );
  }
}

PatientNotes.propTypes = {
  patientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientNotes);
